<template>
  <el-dialog
    title="价格调整"
    :visible.sync="visible"
    width="400px"
    @close="$emit('update:show', false)"
  >
    <el-form size="small" :model="model" :rules="rules" ref="form">
      <el-form-item prop="discount_remark" label="备注" size="small">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2 }"
          v-model="model.discount_remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { updateCommodityOrderDiscount } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {},
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await updateCommodityOrderDiscount(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>